import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { RootState } from '../../../reducers';
import * as _actionsBasket from '../../../actions/basket';
import * as _actionsFilters from '../../../actions/filters';
import * as actions from '../../../actions/index';
import { TypeContainer } from '../../../actions/typeContainer';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router';
import Step3 from '../../Journey2/Step3';
import { PartiallyIntegratedUserDataEC } from '../../../reducers/app';

interface Props {
  actionsBasket: typeof _actionsBasket;
  actionsFilters: typeof _actionsFilters;
  match: any;
  userDataEC: PartiallyIntegratedUserDataEC;
  dataPrefilledJ3: boolean;
  containers: TypeContainer;
}

const Step1 = ({ actionsBasket, userDataEC, containers, actionsFilters }: Props) => {
  const [copyingBasket, setCopyingBasket] = React.useState(false);

  const params = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    actionsFilters.fetchBookingDates();
    actionsBasket.fetchBasketInfo({
      basket: Number(params.step),
    });

    actionsBasket.getBasketContent({
      basket: Number(params.step),
    });
  }, []);

  const next = () => {
    setCopyingBasket(true);
    actionsBasket
      .copyBasket({
        basket: Number(params.step),
        startdate: userDataEC.startDate,
        duration: userDataEC.duration,
      })
      .then((res) => {
        if (res) {
          setCopyingBasket(false);
          navigate('/journey3/1?basketId=' + res.data.basket + '&basketreference=' + res.data.basketreference);
        } else {
          setCopyingBasket(false);
        }
      });
  };

  return (
    <Step3
      nextStepCallback={next}
      prevStepCallback={() => {
        navigate('/journey3/campaigns');
      }}
      isLoading={copyingBasket}
      isSkipNextStep={true}
    />
  );
};

function mapStateToProps(state: RootState, ownProps: any) {
  return {
    ...ownProps,
    ...state.app,
    ...state.router,
    locales: state.locales,
  };
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
  return {
    actionsBasket: bindActionCreators(_actionsBasket as any, dispatch),
    actionsFilters: bindActionCreators(_actionsFilters as any, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Step1);
